/**
 * Free-shipping progress bar — live updates on cart change.
 * Matches Liquid rules: threshold from settings, always-free via product tag
 * (resolved server-side; refresh via Section Rendering when needed).
 */
(function () {
  const BAR_SELECTOR = '[data-atj-free-shipping-bar]';
  let syncTimer = null;
  let syncing = false;

  function formatMoney(cents) {
    const value = Number(cents) || 0;
    try {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        const format = window.theme?.moneyFormat || window.theme?.money_format;
        if (format) {
          const formatted = Shopify.formatMoney(value, format);
          return formatted.replace(/(\d)\s+€/g, '$1 €').replace(/€\s+/g, '€ ');
        }
      }
    } catch (e) {
      /* fall through */
    }
    const amount = (value / 100).toLocaleString('lv-LV', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return amount + ' €';
  }

  function buildMessage(bar, unlocked, remainingCents) {
    if (unlocked) {
      return bar.dataset.msgUnlocked || '';
    }
    const amount = formatMoney(remainingCents);
    const template = bar.dataset.msgRemaining || 'Vēl __AMOUNT__ līdz bezmaksas piegādei';
    return template.replace('__AMOUNT__', amount);
  }

  function applyState(bar, { total, itemCount, alwaysFree }) {
    if (!bar) return;
    const threshold = Number(bar.dataset.thresholdCents) || 4400;
    const unlocked = Boolean(alwaysFree) || total >= threshold;
    let pct = threshold > 0 ? Math.round((total / threshold) * 100) : 100;
    if (pct > 100) pct = 100;
    if (pct < 0) pct = 0;
    if (unlocked) pct = 100;

    const remaining = Math.max(0, threshold - total);
    const message = buildMessage(bar, unlocked, remaining);

    bar.dataset.cartTotal = String(total);
    bar.dataset.itemCount = String(itemCount);
    bar.dataset.alwaysFree = alwaysFree ? 'true' : 'false';
    bar.dataset.unlocked = unlocked ? 'true' : 'false';
    bar.classList.toggle('is-unlocked', unlocked);

    const textEl = bar.querySelector('[data-atj-fsb-text]');
    const track = bar.querySelector('[data-atj-fsb-track]');
    const fill = bar.querySelector('[data-atj-fsb-fill]');

    if (textEl) textEl.textContent = message;
    if (fill) fill.style.width = pct + '%';
    if (track) {
      track.setAttribute('aria-valuenow', String(pct));
      track.setAttribute('aria-valuetext', message);
    }
  }

  function findMount() {
    return (
      document.querySelector('#CartDrawer-CartItems') ||
      document.querySelector('#main-cart-items .js-contents') ||
      document.querySelector('cart-drawer-items .drawer__contents')
    );
  }

  function parseSectionBar(html) {
    if (!html) return null;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(BAR_SELECTOR);
  }

  async function fetchBarFromSection() {
    const url = `${window.routes.cart_url}?section_id=cart-drawer`;
    const response = await fetch(url);
    const text = await response.text();
    return parseSectionBar(text);
  }

  async function fetchBarFromCartPage() {
    const main = document.getElementById('main-cart-items');
    if (!main?.dataset?.id) return null;
    const url = `${window.routes.cart_url}?section_id=${main.dataset.id}`;
    const response = await fetch(url);
    const text = await response.text();
    return parseSectionBar(text);
  }

  async function syncFromSection() {
    if (syncing) return;
    syncing = true;
    try {
      let next = null;
      if (document.querySelector('cart-drawer')) {
        next = await fetchBarFromSection();
      }
      if (!next && document.getElementById('main-cart-items')) {
        next = await fetchBarFromCartPage();
      }

      const current = document.querySelector(BAR_SELECTOR);
      if (next) {
        if (current) {
          current.replaceWith(next);
        } else {
          const mount = findMount();
          if (mount) mount.prepend(next);
        }
      } else if (current) {
        current.remove();
      }
    } catch (e) {
      console.error('[atj-free-shipping-bar]', e);
    } finally {
      syncing = false;
    }
  }

  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(() => {
      syncFromSection();
    }, 80);
  }

  function cartAlreadyMatchesBar(cart) {
    const bar = document.querySelector(BAR_SELECTOR);
    if (!bar || !cart) return false;
    return (
      Number(bar.dataset.cartTotal) === Number(cart.total_price) &&
      Number(bar.dataset.itemCount) === Number(cart.item_count)
    );
  }

  function onCartUpdate(event) {
    const cart = event?.cartData;
    if (cart && Number(cart.item_count) === 0) {
      document.querySelector(BAR_SELECTOR)?.remove();
      return;
    }
    if (cartAlreadyMatchesBar(cart)) return;
    scheduleSync();
  }

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    }

    document.addEventListener('shopify:section:load', () => {
      /* theme editor */
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
